module.exports = __webpack_public_path__ + "static/img/6.35dcacf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/zh/6.png
// module id = ZZ62
// module chunks = 0